module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"appStore":"Loja de Apps","cta":"Agende uma demonstração","use":"Comece a usar agora","login":"Entrar"},"en":{"appStore":"App Store","cta":"Schedule a demo","use":"Start using now","login":"Login"}}')
  delete Component.options._Ctor
}
